// extracted by mini-css-extract-plugin
export default {"wrapper":"TextArea_wrapper__tZmWD","measure":"TextArea_measure__VXsiH","input":"TextArea_input__r3s9I","fullHeight":"TextArea_fullHeight__SZQbl"};